import { configureStore } from '@reduxjs/toolkit'
import reportsReducer from './reports/reportsSlice';

export default configureStore({
    reducer: {
        reportsStore: reportsReducer
    }
})
